export default {
  "ui:title": "",
  "ui:description": "",
  // organization: {
  //   'ui:tooltip': 'Represents the Organization',
  //   'ui:title': 'Organization',
  //   'ui:placeholder': 'ex: westfield'
  // },
  mall: {
    "ui:placeholder": "ex: westfield les 4 temps",
    "ui:widget": "MallsSelectWidget",
  },

  "ui:submitButtonOptions": {
    norender: true,
  },
};
